// src/stores/usePocketAuthStore.js
import { ref } from 'vue'
import { defineStore } from 'pinia'
import usePocketbase from '@/composables/usePocketbase'

export const usePocketAuthStore = defineStore('pocketAuth', () => {
  const user = ref(null)
  const member = ref(null)
  const isLoading = ref(false)

  const requestOTP = async (email) => {
    const pb = usePocketbase()
    await pb.collection('users').requestVerification(email)
  }

  const confirmOTP = async (email, token) => {
    const pb = usePocketbase()
    isLoading.value = true

    try {
      const authData = await pb
        .collection('users')
        .confirmVerification(token, email)

      user.value = authData.record

      try {
        member.value = await pb
          .collection('members')
          .getFirstListItem(`user="${user.value.id}"`)
      } catch {
        member.value = await pb.collection('members').create({
          user: user.value.id,
          email: user.value.email,
          name: '',
        })
      }
    } finally {
      isLoading.value = false
    }
  }

  const logout = () => {
    const pb = usePocketbase()
    pb.authStore.clear()
    user.value = null
    member.value = null
  }

  const tryAutoLogin = async () => {
    const pb = usePocketbase()
    isLoading.value = true
    if (!pb.authStore.isValid) {
      isLoading.value = false
      return
    }

    user.value = pb.authStore.model

    try {
      member.value = await pb
        .collection('members')
        .getFirstListItem(`user="${user.value.id}"`)
    } catch {
      member.value = null
    }

    isLoading.value = false
  }

  return {
    user,
    member,
    isLoading,
    requestOTP,
    confirmOTP,
    logout,
    tryAutoLogin,
  }
})
